import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';

import Routes from './routes';

import 'react-toastify/dist/ReactToastify.css';

export default function App() {
  return <>
    <Routes />
    <ToastContainer />
  </>;
}
